var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerBgCanalPedagogico(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg989",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1600,
    height: 180,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1600 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient-9);\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {\r\n        mix-blend-mode: screen;\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: rgba(0, 114, 147, .42);\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient-7);\r\n      }\r\n\r\n      .cls-14 {\r\n        clip-path: url(#clippath-1);\r\n      }\r\n\r\n      .cls-15 {\r\n        clip-path: url(#clippath-3);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-11);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#linear-gradient-8);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#linear-gradient-10);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: url(#linear-gradient-6);\r\n      }\r\n\r\n      .cls-16 {\r\n        clip-path: url(#clippath-2);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-18 {\r\n        clip-path: url(#clippath);\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: -0.85,
    y: -1.58,
    width: 1609.55,
    height: 185.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: -65.5,
    y: -3.74,
    width: 1672.79,
    height: 188.13
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: -112.55,
    y: -349.75,
    width: 1897.72,
    height: 880.14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -3500.62,
    y1: 1097.63,
    x2: -1671.82,
    y2: 206.16,
    gradientTransform: "translate(-1980.7 -646.33) rotate(-180) scale(1.05 -1.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e2f8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#040930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1752.04,
    y1: 808.15,
    x2: -2406.38,
    y2: 169.41,
    gradientTransform: "translate(-1980.7 -646.33) rotate(-180) scale(1.05 -1.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e2f8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0a246b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#061745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#030d27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#010511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#000104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 13413.15,
    y1: 11302.01,
    x2: 12758.81,
    y2: 10663.27,
    gradientTransform: "translate(-12910.98 11245.26) scale(1.05 -1.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e2f8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0a246b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#061745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#030d27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#010511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#000104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 13627.48,
    y1: 11390.24,
    x2: 12973.13,
    y2: 10751.51,
    gradientTransform: "translate(-16974.92 -1860.13) rotate(44.99) scale(1.05 -1.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e2f8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0a246b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#061745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#030d27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#010511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#000104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -2004.64,
    y1: 825.67,
    x2: -2658.98,
    y2: 186.94,
    gradientTransform: "translate(-1035.37 -1671.3) rotate(-135.01) scale(1.05 -1.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e2f8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0a246b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#061745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#030d27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#010511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#000104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 12778.09,
    y1: 11453.96,
    x2: 12123.75,
    y2: 10815.22,
    gradientTransform: "translate(-12910.98 11245.26) scale(1.05 -1.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e2f8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0a246b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#061745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#030d27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#010511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#000104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 12572.79,
    y1: 11027.13,
    x2: 11918.44,
    y2: 10388.4,
    gradientTransform: "translate(-12910.98 11245.26) scale(1.05 -1.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e2f8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0a246b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#061745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#030d27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#010511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#000104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -2094.92,
    y1: 707.95,
    x2: -1645.88,
    y2: 1136.57,
    gradientTransform: "translate(-702.59 -1686.27) rotate(-134.99) scale(1.05 -1.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e2f8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0a246b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#061745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#030d27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#010511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#000104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -3143.65,
    y1: 165.86,
    x2: -2694.62,
    y2: 594.49,
    gradientTransform: "translate(-782 -2627.71) rotate(-134.99) scale(1.05 -1.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e2f8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0a246b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#061745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#030d27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#010511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#000104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 11543.2,
    y1: 7466.99,
    x2: 11992.24,
    y2: 7895.61,
    gradientTransform: "translate(-13854.17 -2900.16) rotate(45.01) scale(1.05 -1.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e2f8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0a246b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#061745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#030d27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#010511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#000104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -2730.85,
    y1: -1078.47,
    x2: -2281.82,
    y2: -649.85,
    gradientTransform: "translate(-2191.52 -949.09) rotate(-134.99) scale(1.05 -1.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e2f8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0a246b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#061745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#030d27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#010511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#000104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 0.88,
    y: -1.46,
    width: 1605.57,
    height: 187.34
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g987",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fundo"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g980"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect954",
    className: "cls-17",
    x: -112.55,
    y: -349.75,
    width: 1898.52,
    height: 880.14
  }), /*#__PURE__*/React.createElement("path", {
    id: "path956",
    className: "cls-4",
    d: "M595.14-588.58l53.92,53.9c14.89,14.88,14.89,39.02,0,53.9L73.24,94.86c-14.89,14.88-39.03,14.88-53.92,0l-53.93-53.91c-14.89-14.88-14.89-39.02,0-53.9l575.83-575.64c14.89-14.88,39.03-14.88,53.92,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path960",
    className: "cls-11",
    d: "M368.26,219.79l-53.92-53.9c-14.89-14.88-14.89-39.02,0-53.9L890.17-463.66c14.89-14.88,39.03-14.88,53.92,0l53.92,53.9c14.89,14.88,14.89,39.02,0,53.9L422.19,219.79c-14.89,14.88-39.03,14.88-53.92,0h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect962",
    className: "cls-10",
    d: "M444.15-290.41h872.18c5.04,0,9.14,4.1,9.14,9.14v134.22c0,5.04-4.09,9.13-9.13,9.13H444.16c-5.04,0-9.14-4.1-9.14-9.14v-134.22c0-5.04,4.09-9.13,9.13-9.13Z",
    transform: "translate(409.13 559.62) rotate(-44.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect964",
    className: "cls-6",
    d: "M66.98,352.18h814.2c21.05,0,38.14,17.09,38.14,38.14v76.25c0,21.03-17.08,38.11-38.11,38.11H67c-21.05,0-38.14-17.09-38.14-38.14v-76.25c0-21.03,17.08-38.11,38.11-38.11Z",
    transform: "translate(-164.09 460.62) rotate(-44.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path966",
    className: "cls-9",
    d: "M-295.69,60.98l-53.92-53.9c-14.89-14.88-14.89-39.02,0-53.9L226.22-622.47c14.89-14.88,39.03-14.88,53.92,0l53.92,53.9c14.89,14.88,14.89,39.02,0,53.9L-241.76,60.98c-14.89,14.88-39.03,14.88-53.92,0h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path968",
    className: "cls-2",
    d: "M-510.33,507.07l-53.92-53.9c-14.89-14.88-14.89-39.02,0-53.9L11.57-176.38c14.89-14.88,39.03-14.88,53.92,0l53.92,53.9c14.89,14.88,14.89,39.02,0,53.9L-456.41,507.07c-14.89,14.88-39.03,14.88-53.92,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect970",
    className: "cls-7",
    x: -492.3,
    y: 355.46,
    width: 811.38,
    height: 41.42,
    transform: "translate(-291.41 48.97) rotate(-45.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect972",
    className: "cls-1",
    x: 604.15,
    y: -211.11,
    width: 811.38,
    height: 41.42,
    transform: "translate(430.55 658.39) rotate(-45.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect974",
    className: "cls-8",
    x: 200.83,
    y: 106.27,
    width: 811.38,
    height: 41.42,
    transform: "translate(87.91 466.15) rotate(-45.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect976",
    className: "cls-5",
    x: -190.74,
    y: 242.83,
    width: 811.38,
    height: 41.42,
    transform: "translate(-123.39 229.24) rotate(-45.01)"
  }))))))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect8980",
    className: "cls-12",
    x: -62.9,
    y: -3.63,
    width: 1669.35,
    height: 189.52
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerBgCanalPedagogico);
export default __webpack_public_path__ + "static/media/banner_bg_canal_pedagogico.26e722948df89b0be158d5a56f943f9c.svg";
export { ForwardRef as ReactComponent };